export const NOTIFICATION_SOURCE_TYPES = [
  'EVENT',
  'PAYMENT',
  'INCIDENT',
  'MEETING',
  'AGREEMENT',
  'NOTICE',
  'POLL',
  'PROPOSAL',
  'DOCUMENT',
  'USER_NOTIFICATION',
] as const;

export type NotificationSourceType = typeof NOTIFICATION_SOURCE_TYPES[number];

export type NotificationCategory = Lowercase<NotificationSourceType>;

export interface NotificationItem {
  id: number;
  sourceId: string;
  communityId: string;
  type: NotificationCategory;
  sourceType: NotificationSourceType;
  userNotificationType?: string | null;
  title: string;
  description?: string;
  createdAt: Date;
}
